export default __webpack_public_path__ + "static/media/Grow your Brand with PR.96889d74.png";